'use client';

import { __styles } from "@griffel/react";
import { typographyStyles } from "@fluentui/react-theme";
export const title1ClassNames = {
  root: 'fui-Title1'
};
/**
 * Styles for the root slot
 */
export const useTitle1Styles = /*#__PURE__*/__styles({
  root: {
    Bahqtrf: "fk6fouc",
    Be2twd7: "fccw675",
    Bhrd7zp: "fl43uef",
    Bg96gwp: "f1ebx5kk"
  }
}, {
  d: [".fk6fouc{font-family:var(--fontFamilyBase);}", ".fccw675{font-size:var(--fontSizeHero800);}", ".fl43uef{font-weight:var(--fontWeightSemibold);}", ".f1ebx5kk{line-height:var(--lineHeightHero800);}"]
});